import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';
import * as fromContextData from './context-data.reducer';

export const contextDataKey = 'context-feature';

export const selectContextDataState =
  createFeatureSelector<fromContextData.ContextDataState>(contextDataKey);

export const selectContextData = createSelector(
  selectContextDataState,
  fromContextData.contextData,
);

export const selectProductQuery = createSelector(
  selectContextDataState,
  fromContextData.productQuery,
);

export const selectProgramEventCost = createSelector(
  selectContextDataState,
  fromContextData.eventCost,
);

export const selectMultipleRegistrations = createSelector(
  selectContextDataState,
  fromContextData.multipleRegistrations,
);

export const selectCurrentRegistration = createSelector(
  selectContextDataState,
  fromContextData => {
    const signup = fromContextData.context?.signups[0];
    return signup?.registration;
  },
);

export const selectOrganizationId = createSelector(
  selectContextDataState,
  fromContextData.contextOrganizationId,
);

export const selectOrganizationName = createSelector(
  selectContextDataState,
  fromContextData.contextOrganizationName,
);

export const selectHasRegistrationCancellationRecommendation = createSelector(
  selectContextDataState,
  cd => {
    const helper = 'verticalinsure-registrationcancellation-recommend';
    const channels = cd?.context?.enabledSalesChannels ?? [];
    return channels.some(ch => (ch?.toLowerCase?.() ?? ch) === helper);
  },
);

export const selectCustomerPaysFee = createSelector(
  selectContextDataState,
  fromContextData.customerPaysFee,
);

export const selectSeApiToken: MemoizedSelector<object, string | undefined> =
  createSelector(selectContextData, cd => cd?.seApiToken);

export const selectBaseUriProxy: MemoizedSelector<object, string | undefined> =
  createSelector(selectContextData, data => {
    const uri = data?.hostApplication?.baseUriProxy;
    return uri?.endsWith('/') ? uri?.slice(0, -1) : uri;
  });
